import { createPinia } from 'pinia';
import useAppStore from './modules/app';
import useUserStore, { ensureUserHydrated } from './modules/user';
import usePrefetchStore from './modules/prefetch';

export const createStore = () => createPinia();

const pinia = createStore();

export {
  ensureUserHydrated,
  useAppStore,
  useUserStore,
  usePrefetchStore,
};

export default pinia;
